// extracted by mini-css-extract-plugin
export default {"updateButtons":"recRendering_updateButtons__wLoGJ"};